import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "66",
  height: "40",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.143 9.424a1 1 0 0 1 1.714 0l2.875 4.776a1 1 0 0 0 .63.459l5.432 1.258a1 1 0 0 1 .53 1.63l-3.655 4.21a1 1 0 0 0-.241.742l.482 5.554a1 1 0 0 1-1.387 1.007l-5.133-2.175a1 1 0 0 0-.78 0l-5.133 2.175a1 1 0 0 1-1.387-1.007l.482-5.554a1 1 0 0 0-.24-.742l-3.655-4.21a1 1 0 0 1 .53-1.63l5.43-1.258a1 1 0 0 0 .631-.459zM41.284 25.66q-1.329 0-2.358-.456-1.023-.46-1.614-1.267a3.12 3.12 0 0 1-.602-1.858h2.83q.017.381.244.677.227.29.62.454.39.165.891.165.5 0 .881-.176.387-.181.602-.495.216-.318.21-.727a1.15 1.15 0 0 0-.232-.727 1.54 1.54 0 0 0-.676-.494 2.7 2.7 0 0 0-1.023-.177h-1.13v-2h1.13q.517 0 .909-.17.397-.17.62-.477.22-.312.215-.716a1.2 1.2 0 0 0-.187-.688 1.24 1.24 0 0 0-.529-.465 1.75 1.75 0 0 0-.778-.165q-.465 0-.847.165-.375.165-.596.465-.222.301-.233.7h-2.688q.011-1.041.58-1.83.568-.795 1.545-1.245.984-.449 2.239-.449 1.25 0 2.199.438t1.477 1.193q.528.75.528 1.7.006.982-.642 1.618-.642.637-1.653.785v.09q1.352.16 2.04.875.693.717.687 1.79 0 1.011-.596 1.796-.592.778-1.648 1.227-1.05.443-2.415.443m9.735-1.842v-8.227h2.29v8.227zm-2.972-2.966v-2.295h8.227v2.295z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }